import { render } from "./TheSettingsLinks.vue?vue&type=template&id=93855c6c&scoped=true&ts=true"
import script from "./TheSettingsLinks.vue?vue&type=script&lang=ts"
export * from "./TheSettingsLinks.vue?vue&type=script&lang=ts"

import "./TheSettingsLinks.vue?vue&type=style&index=0&id=93855c6c&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-93855c6c"]])

export default __exports__